module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._t("header", [_c('h4', [_vm._v(_vm._s(_vm.kombox.content) + " - " + _vm._s(_vm.name()))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "btn btn-default btn-lg",
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "15px",
      "border": "0 none"
    },
    attrs: {
      "type": "link",
      "title": "Fenster schließen"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.acdText == 'Off'),
      expression: "acdText == 'Off'"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine ACD Eingrichtet")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.acdKey),
      expression: "!acdKey"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Nicht an der ACD angemeldet")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.acdKey && _vm.acdText != 'Off'),
      expression: "acdKey && acdText != 'Off'"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("ACD integration (noch) nicht implementiert ! ACD: " + _vm._s(_vm.acdText) + " ACD-Login: " + _vm._s(_vm.acdKey))]), _vm._v(" "), _c('form', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, _vm._l((_vm.textTemplates), function(textTemplate, i) {
    return _c('div', {}, [_c('label', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v(_vm._s(textTemplate.headline))]), _vm._v(" "), _c('ul', {}, _vm._l((textTemplate.contents), function(content, j) {
      return _c('li', {
        on: {
          "dblclick": function($event) {
            return _vm.onClickAddTemplate(i, j)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(content) + "\n                  "), _c('button', {
        staticClass: "btn btn-default pull-right",
        staticStyle: {
          "border": "0 none",
          "padding": "0px",
          "color": "#aaa"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.onClickAddTemplate(i, j)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-file-text",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "fa fa-arrow-right",
        attrs: {
          "aria-hidden": "true"
        }
      })])])
    }), 0)])
  }), 0)])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              close\n            ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6753895a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/PhoneTool.vue
// module id = 280
// module chunks = 0